import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Sparkles } from "lucide-react";
import { useTranslation } from "@/hooks/useTranslation";

interface AiDisclosureModalProps {
  isOpen: boolean;
  onConfirm: () => void;
}

export const AiDisclosureModal = ({
  isOpen,
  onConfirm,
}: AiDisclosureModalProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} modal>
      <DialogContent
        className="max-w-md"
        hideCloseButton
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary">
            <Sparkles className="h-6 w-6" />
          </div>
          <DialogTitle className="text-center">
            {t("chat.ai_disclosure_title")}
          </DialogTitle>
          <DialogDescription className="text-center text-base leading-relaxed">
            {t("chat.ai_disclosure_body")}
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="sm:justify-center">
          <Button variant="romantic" className="w-full sm:w-auto" onClick={onConfirm}>
            {t("chat.ai_disclosure_confirm")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
